import { ref } from 'vue';

// 机器人（CTC-AI-Robot）抽屉的全局单例状态，供页面按钮（如「提需求」）外部打开。
// chatBot/index.vue 绑定这两个 ref；默认宽度（窗口 50%）与拖拽/窗口收敛均在该组件内维护。
export const chatBotOpen = ref(false);
export const chatBotWidth = ref(580);

// 打开机器人抽屉（宽度用机器人自身默认 = 窗口 50%）。
export function openChatBot() {
  chatBotOpen.value = true;
}
